import React, { useMemo } from 'react';
import { evaluateWorkyPasswordCriteria } from './WorkyPasswordValidationService';
import type { WorkyPasswordCriterionEvaluation } from './WorkyPasswordCriteriaInterfaces';

const WorkyPasswordCriteriaChecklist = ({
    password,
    isVisible,
}: {
    password: string;
    isVisible: boolean;
}): JSX.Element | null => {
    const passwordCriteria: readonly WorkyPasswordCriterionEvaluation[] = useMemo(
        (): readonly WorkyPasswordCriterionEvaluation[] => evaluateWorkyPasswordCriteria(password),
        [password]
    );

    if (!isVisible) {
        return null;
    }

    return (
        <ul className="worky-password-criteria-list" aria-live="polite">
            {passwordCriteria.map((criterionEvaluation: WorkyPasswordCriterionEvaluation) => {
                const criterionClassName: string = criterionEvaluation.isMet
                    ? 'worky-password-criterion worky-password-criterion-met'
                    : 'worky-password-criterion worky-password-criterion-unmet';

                return (
                    <li key={criterionEvaluation.id} className={criterionClassName}>
                        <span className="worky-password-criterion-icon" aria-hidden="true">
                            {criterionEvaluation.isMet ? '✓' : '✕'}
                        </span>
                        <span className="worky-password-criterion-label">{criterionEvaluation.label}</span>
                    </li>
                );
            })}
        </ul>
    );
};

export { WorkyPasswordCriteriaChecklist };
